import axios from 'axios'
import config2 from './config'
// import store from 'your/store/path/store'

export default function setup() {
  axios.defaults.baseURL = config2('api.baseUrl')
  axios.defaults.timeout = config2('api.timeout')
  axios.defaults.withCredentials = true

  axios.interceptors.request.use(async (config) => {

    // const getToken = await axios.get('/auth/rtoken')
    // config.headers.Authorization = `Bearer ${getToken.data.accessToken}`

    // console.log('interceptors===', config)
    // console.log('getToken===', getToken)
    return config;
  }, function (err) {
    return Promise.reject(err);
  });
}

